import { useState, type FormEvent } from 'react';
import { api, fmt, type Me } from '../api';
import { ErrorNote, Field, Note, PageHead, Spinner } from '../components/ui';

export default function Account({ me }: { me: Me }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const [done, setDone] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setDone(false);
    try {
      await api.post('/api/auth/password', { current, next });
      setDone(true);
      setCurrent('');
      setNext('');
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <PageHead title="Account" sub={me.email} />
      <div className="grid-2" style={{ alignItems: 'start' }}>
        <section className="card">
          <h2 className="mt0">Your access</h2>
          <dl className="kv">
            <dt>Role</dt><dd>{me.role === 'owner' ? 'Owner' : 'Demo account'}</dd>
            <dt>Access until</dt><dd>{me.expiresAt ? fmt.day(me.expiresAt) : 'No expiry'}</dd>
            {me.role === 'demo' ? (
              <>
                <dt>Phone calls</dt><dd>{me.limits.dailyCalls} per day, up to {fmt.duration(me.limits.maxCallSeconds * 1000)} each</dd>
                <dt>Browser sessions</dt><dd>Up to {fmt.duration(me.limits.maxWebSeconds * 1000)} each</dd>
              </>
            ) : null}
          </dl>
        </section>
        <section className="card">
          <h2 className="mt0">Change password</h2>
          {done ? <Note tone="success">Password changed. Other devices were signed out.</Note> : null}
          <ErrorNote error={error} />
          <form onSubmit={submit}>
            <Field label="Current password" htmlFor="cur">
              <input id="cur" type="password" autoComplete="current-password" required value={current} onChange={(e) => setCurrent(e.target.value)} />
            </Field>
            <Field label="New password" htmlFor="new" hint="At least 10 characters.">
              <input id="new" type="password" autoComplete="new-password" required minLength={10} value={next} onChange={(e) => setNext(e.target.value)} />
            </Field>
            <button className="btn primary" disabled={busy}>{busy ? <Spinner label="Saving" /> : null} Change password</button>
          </form>
        </section>
      </div>
    </>
  );
}
